import * as React from "react";
import "../Styles/style.css";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";
import { awsImageURL, baseUrl } from "../../api/ipconfig";
import Popover from "@mui/material/Popover";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import UserDetails from "./userDetails";
import MyadsNavigation from "./myads-navigation";
import { AuthContext } from "../../context/AuthContext";

export default function MySavedAds() {
  const { user } = React.useContext(AuthContext);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [popoverState, setPopoverState] = useState({});

  const handleClick = (event, postId) => {
    setPopoverState((prevState) => ({
      ...prevState,
      [postId]: true,
    }));
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (postId) => {
    setPopoverState((prevState) => ({
      ...prevState,
      [postId]: false,
    }));
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "12" : undefined;

  const fetchUserPosts = async () => {
    try {
      const response = await axios.get(`${baseUrl}/wishlist`, {
        params: {
          user_id: user?.id,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response.data, " user post data ====");
      setPosts(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching user posts:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserPosts();
  }, []);

  const history = useHistory();

  const openPost = (postId) => {
    history.push(`/vehicle-details/${postId}`);
  };

  const token = localStorage.getItem("token");

  const deletePost = async (wishlistId) => {
    try {
      await axios.delete(
        `${baseUrl}/fame/deletewishlist`,

        {
          params: {
            userId: user?.id,
            wishlistId: wishlistId,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Post Removed:", wishlistId);
      fetchUserPosts();
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  return (
    <>
      <div className="MyAds_main">
        <UserDetails />
        <div className="container-md MyAds_body">
          <div className="row pb-5">
            <div className="col-lg-2  p-0">
              <MyadsNavigation />
            </div>
            <div className="col-lg-10 ">
              <div className="MyAdsArea_main ">
                {loading ? (
                  <div className="No_ads_loading p-3 text-center">
                    <div>
                      <div className="row">
                        <div className="col-lg-3">
                          <Skeleton
                            animation="wave"
                            variant="rounded"
                            width="100%"
                            height={170}
                          />
                        </div>
                        <div className="col-lg-9 d-flex flex-column justify-content-between">
                          <div className="d-flex align-items-top justify-content-between">
                            <div className="text-start">
                              <h4>
                                <Skeleton
                                  animation="wave"
                                  variant="rounded"
                                  width={300}
                                  height={20}
                                />
                              </h4>
                              <h6>
                                <Skeleton
                                  animation="wave"
                                  variant="rounded"
                                  width={150}
                                  height={20}
                                />
                              </h6>
                            </div>
                            <div>
                              <Skeleton
                                animation="wave"
                                variant="rounded"
                                width={8}
                                height={20}
                              />
                            </div>
                          </div>
                          <div className="d-flex align-items-center ">
                            <p>
                              <Skeleton
                                sx={{ marginRight: 2 }}
                                animation="wave"
                                variant="rounded"
                                width={30}
                                height={15}
                              />
                            </p>
                            <p>
                              <Skeleton
                                sx={{ marginRight: 2 }}
                                animation="wave"
                                variant="rounded"
                                width={30}
                                height={15}
                              />
                            </p>
                            <p>
                              <Skeleton
                                sx={{ marginRight: 2 }}
                                animation="wave"
                                variant="rounded"
                                width={30}
                                height={15}
                              />
                            </p>
                          </div>
                          <div>
                            <Skeleton
                              animation="wave"
                              variant="rounded"
                              width={60}
                              height={20}
                            />
                          </div>
                          <div className=" d-flex justify-content-end ">
                            <Skeleton
                              animation="wave"
                              variant="rounded"
                              width={100}
                              height={35}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : posts.length ? (
                  posts.map((post) => (
                    <div className="myAd p-3 mb-4" key={post.postId}>
                      <div className="row">
                        <div className="col-lg-3 Myads_photos">
                          <img
                            src={`${awsImageURL}/posts/${post.post_token}/${post?.post?.cover}`}
                            alt={`${post?.makeName} ${post?.modelName} ${post?.yearName}`}
                            srcSet=""
                            onError={(e) => {
                              e.target.src =
                                "https://gallery.famewheels.com/appgallery/no-image.png";
                            }}
                          />
                        </div>
                        <div className="col-lg-9">
                          <div className="d-flex align-items-top justify-content-between">
                            <div className="vehicleDetails">
                              <h4>
                                {" "}
                                {`${post?.makeName} ${post?.modelName} ${post?.yearName}`}{" "}
                              </h4>
                              <h6>PKR: {post?.price}</h6>
                            </div>
                            <div key={post.postId}>
                              <Button
                                sx={{ padding: 0, minWidth: "unset" }}
                                aria-describedby={post.postId}
                                variant="text"
                                onClick={(event) =>
                                  handleClick(event, post.postId)
                                }
                              >
                                <MoreVertIcon sx={{ color: "#000000" }} />
                              </Button>
                              <Popover
                                id={id}
                                open={popoverState[post.postId] || false}
                                anchorEl={anchorEl}
                                onClose={() => handleClose(post.postId)}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "left",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                                elevation={0}
                                className="MyAds_options"
                                key={post.postId}
                              >
                                <div>
                                  <button
                                    className="btn"
                                    onClick={() => deletePost(post.wishlistId)}
                                  >
                                    <DeleteIcon
                                      sx={{ fontSize: 20, marginRight: 1 }}
                                    />
                                    Remove Ad
                                  </button>
                                </div>
                              </Popover>
                            </div>
                          </div>
                          <div className="text-end ad_controls">
                            <button
                              key={post.postId}
                              onClick={() => openPost(post.postId)}
                              className="btn fw-primary ms-3"
                            >
                              View Ad
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="No_ads p-3 text-center">
                    <p>no active ads</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
